























































































































import InputGroup from "@/components/InputGroup.vue";
import ParentView from "@/components/ParentView.vue";
import Table from "@/components/Table.vue";
import useProfile from "@/composables/useProfile";
import injectStrict from "@/utilities/injectstrict";
import { maxLength, required } from "@/utilities/validators";
import { defineComponent, toRefs, ref, computed } from "@vue/composition-api";
import useVuelidate from "@vuelidate/core";
import { ProfileKey } from "../symbols";
import { useResendEmailMutation } from "@/graphql/types";
import { TableField } from "@/types/TableField";

export default defineComponent({
  components: { ParentView, InputGroup, Table },
  setup(_, { root }) {
    const { canChangeProfileEmail, canResendVerifyEmail } = useProfile();
    const user = injectStrict(ProfileKey);
    const v$ = useVuelidate(useValidations(), { ...toRefs(user) });

    const resendComplete = ref(false);
    const { mutate, loading, onDone } = useResendEmailMutation({});
    const { profile } = useProfile();

    function resend() {
      mutate({
        input: profile.value?.id,
      });
    }

    onDone(() => {
      resendComplete.value = true;
    });

    const localAdminsLoading = ref(false);

    const localAdmins = computed(() =>
      (user.localAdmins ?? [])
        .filter((admin) => !!admin)
        .map((admin) => ({
          fullname: admin?.fullname,
          email: admin?.email,
        }))
    );

    const localAdminFields = computed<TableField[]>(() => [
      {
        key: "fullname",
        label: root.$t("local_admins.fullname") as string,
        sortable: true,
      },
      {
        key: "email",
        label: root.$t("local_admins.email") as string,
        sortable: true,
      },
    ]);

    return {
      canChangeProfileEmail,
      user,
      v$,
      canResendVerifyEmail,
      resendComplete,
      loading,
      resend,
      localAdmins,
      localAdminsLoading,
      localAdminFields,
    };
  },
});

function useValidations() {
  return {
    firstname: { required, maxLength: maxLength(255) },
    lastname: { required, maxLength: maxLength(255) },
    description: { maxLength: maxLength(1024) },
  };
}
